/**
 * @file
 *
 * Loads and initializes Select2 for Today at Elon filters and form controls,
 * including fields backed by the Elon directory.
 */

import jQuery from 'jquery';
import select2 from 'select2';
import { initializeFrontendDirectoryUserSelects } from './modules/select2-directory-users.js';

select2(window, jQuery);

jQuery(function($) {
	$('.sort-util--select').select2({
		allowClear: true,
	});

	$('.select2--multi-select').select2({
		allowClear: true,
		multiple: true,
	});

	$('.select2--simple-select').select2({
		minimumResultsForSearch: -1,
	});

	$('.select2--default-select').select2();

	initializeFrontendDirectoryUserSelects($);
});
